export const PILL_TYPE = {
  CATEGORY: "category",
  TAG: "tag",
};

export const PILL_DATA = {
  NAME: "t3",
  URL: "t4",
};
